<section class="wrapper">
  <header class="row">
    <div class="col-xs-9">
      <h1 i18n>Two Factor Authentications</h1>
      <p class="text-gray"><span i18n>Username:</span> <span class="text-success">{{credentialUsername()}}</span></p>
    </div>
    <div class="col-xs-3 text-right">
      <button class="btn border border-primary text-primary" (click)="goBack()">
        <i class="icon-left-open-big"></i>
        <span i18n>Back</span>
      </button>
    </div>
  </header>

  <div class="row">
    <div class="col-xs-12">
      <p class="box box-warning" i18n>
        Your organisation has enforced two factor authentication on your account. You cannot turn it off, but you can add or change your second steps.
      </p>

      @for (mfa of mfas(); track mfa) {
        <div class="row row-bordered">
          <div class="col-xs-8">
            <p>{{ readableName[mfa.type] }}</p>
            <div class="text-gray" i18n>Registered on {{ mfa.createdAt | date:'medium' }}</div>
          </div>
          <div class="col-xs-4 text-right">
            <ul class="list-inline list-unstyled">
              <li>@if (canReplaceMFA(mfa)) {
                <button class="btn btn-sm btn-primary" (click)="createMFA(mfa.type)" [attr.aria-label]="replaceLabel(mfa.type)" i18n>Replace</button>
              }</li>
              <li>@if (canDelete()) {
                <button class="btn btn-sm btn-danger" (click)="deleteMFA(mfa.id)" [attr.aria-label]="removeLabel(mfa.type)" i18n>Remove</button>
              }</li>
            </ul>
          </div>
        </div>
      }
    </div>
  </div>

  <div class="row">
    <div class="col-xs-12">
      @if (canAdd()) {
        <button class="btn btn-primary add-credential" (click)="createMFA()">
          <i class="icon-plus"></i>
          <span i18n>Setup two factor authentication</span>
        </button>
      }
    </div>
  </div>

</section>
